import React from "react";

interface IProps {
  metadata?: any;
  logArray?: { msg: string; [key: string]: any }[] | null;
}

class ErrorBoundary extends React.Component<IProps, { hasError: boolean }> {
  metadata: any;
  logArray: { msg: string; [key: string]: any }[] | undefined;

  constructor(props: IProps) {
    super(props);
    this.metadata = props.metadata;
    this.logArray = Array.isArray(props.logArray) ? props.logArray : undefined;
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (Array.isArray(this.logArray)) {
      this.logArray.push({ msg: "ErrorBoundary caught an error", error, errorInfo, metadata: this.metadata });
    } else {
      console.log("ErrorBoundary caught an error:", error);
      console.log("Error details (componentStack):", errorInfo.componentStack);
    }
  }

  render() {
    if (this.state.hasError) {
      return <h3>Something went wrong.</h3>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
